export enum StandardEmitEvents {
  INPUT = 'input',
  CHANGE = 'change',
  SUBMIT = 'submit',
  CLICK = 'click',
  DBLCLICK = 'dblclick',
  MOUSEENTER = 'mouseenter',
  MOUSELEAVE = 'mouseleave',
  MOUSEMOVE = 'mousemove',
  KEYDOWN = 'keydown',
  KEYUP = 'keyup',
  BLUR = 'blur',
  FOCUS = 'focus',
  SCROLL = 'scroll',
  MOUSEDOWN = 'mousedown',
  MOUSEUP = 'mouseup',
  MOUSEOVER = 'mouseover',
  MOUSEOUT = 'mouseout',
  WHEEL = 'wheel',
  CONTEXTMENU = 'contextmenu',
  DRAGSTART = 'dragstart',
  DRAG = 'drag',
  DRAGEND = 'dragend',
  DRAGENTER = 'dragenter',
  DRAGOVER = 'dragover',
  DRAGLEAVE = 'dragleave',
  DROP = 'drop',
  TOUCHSTART = 'touchstart',
  TOUCHMOVE = 'touchmove',
  TOUCHEND = 'touchend',
  TOUCHCANCEL = 'touchcancel',
  TRANSITIONEND = 'transitionend',
  ANIMATIONSTART = 'animationstart',
  ANIMATIONITERATION = 'animationiteration',
  ANIMATIONEND = 'animationend',
  RESIZE = 'resize',
  SELECT = 'select',
  OPEN = 'open',
  CLOSE = 'close'
}
